import ReactGA from "react-ga";
import ReactGA4 from "react-ga4";
import {
  ANALYTICS,
  CUSTOMTRACKERPROD,
  CUSTOMTRACKERSTAGE,
  AGENTSTRACKER,
  INHOUSETRACKER,
} from "../../../constants/constants";
import TagManager from "react-gtm-module";

export let gaInitialized;

export const initInHouseGA = (analytics) => {
  if (!analytics || (analytics && !analytics.ga4MeasurementId)) {
    const trackers = [
      {
        trackingId:
          process.env.NODE_ENV === "production"
            ? CUSTOMTRACKERPROD
            : CUSTOMTRACKERSTAGE,
        gaOptions: { name: INHOUSETRACKER },
      },
    ];
    ReactGA4.initialize(trackers);
    gaInitialized = ANALYTICS.GA4;
  }
};

export const initGoogleAnalytics = (analytics) => {
  if (
    !analytics ||
    (!analytics.ga4MeasurementId && !analytics.googleAnalyticsId)
  )
    return;
  if (analytics.ga4MeasurementId) {
    const trackers = [
      {
        trackingId: analytics.ga4MeasurementId,
        gaOptions: {
          name: AGENTSTRACKER,
          cookieFlags: "Secure",
        },
      },
      {
        trackingId:
          process.env.NODE_ENV === "production"
            ? CUSTOMTRACKERPROD
            : CUSTOMTRACKERSTAGE,
        gaOptions: {
          name: INHOUSETRACKER,
          cookieFlags: "Secure",
        },
      },
    ];
    ReactGA4.initialize(trackers);
    gaInitialized = ANALYTICS.GA4;
  } else if (analytics.googleAnalyticsId) {
    ReactGA.initialize(analytics.googleAnalyticsId);
    gaInitialized = ANALYTICS.GA;
  }
};

export const initGoogleTagManager = (analytics) => {
  if (!analytics || !analytics.googleTagManagerId) return;
  if (analytics.googleTagManagerId) {
    TagManager.initialize({
      gtmId: analytics.googleTagManagerId,
    });
  }
};

export const getAnalytics = () => {
  return gaInitialized && gaInitialized.length > 0 ? gaInitialized : "";
};

export const isGoogleTagManager = (analytics) => {
  if (!analytics || !analytics.googleTagManagerId) return null;
  return analytics.googleTagManagerId;
};

export const googleTagManager = (analytics) => {
  if (!analytics || !analytics.googleTagManagerId) return null;
  return `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    
    gtag('config', '${analytics.googleTagManagerId}');
  `;
};

export const hotjar = (analytics) => {
  if (!analytics || !analytics.hotjarId) return null;
  return `
    (function(h,o,t,j,a,r){
    h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
    h._hjSettings={hjid:${analytics.hotjarId},hjsv:5};
    a=o.getElementsByTagName('head')[0];
    r=o.createElement('script');r.async=1;
    r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
    a.appendChild(r);
    })(window,document,'//static.hotjar.com/c/hotjar-','.js?sv=');
  `;
};

export const facebookPixel = (analytics) => {
  return (
    analytics &&
    analytics.facebookPixelId &&
    `
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
      n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
      document,'script','https://connect.facebook.net/en_US/fbevents.js');
      // Insert Your Facebook Pixel ID below. 
      fbq('init', '${analytics.facebookPixelId}');
      fbq('track', 'PageView');
  `
  );
};

export const facebookPixelNoScript = (analytics) => {
  return (
    analytics &&
    analytics.facebookPixelId &&
    `
    <img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${analytics.facebookPixelId}&amp;ev=PageView&amp;noscript=1" />
  `
  );
};



// WEBPACK FOOTER //
// ./src/components/shared/head/analytics.js